module.exports = __webpack_public_path__ + "img/st-icon-2.b869c9f4.png";